export enum TypesModals {
  OPEN_WP_MODAL = 'modals.OPEN_WP_MODAL',
  CLOSE_WP_MODAL = 'modals.CLOSE_WP_MODAL'
}
